import React from "react";
import "./index.scss";
export const Experience = () => {
  return (
    <div className="Experience">
      <div className="Experience-container">
        <div className="row ms-0 justify-content-center  gx-0 w-100 ">
          <div className="col-12 col-md-4 mx-auto ">
            <p className="experience-title">
              <strong> L’Experience de </strong>
              <br />
              BENTO HABITAT
            </p>
          </div>
          <div className="col-12 col-md-8 mx-auto ">
            <p className="experience-text">
              <strong>Chez Bento Habitat</strong> , nous accompagnons les{" "}
              <strong>particuliers</strong>, <strong>copropriétés</strong>
              <strong>et investisseurs</strong> pour tous leurs projets de
              rénovation : isolation thermique par l’extérieur (ITE), isolation
              intérieure, ravalement de façade, rénovation globale.
              Interventions rapides et garanties dans les{" "}
              <span>
                Hauts-de-Seine (92), le Val-d’Oise, Paris et toute
                l’Île-de-France.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
